import axios from 'axios';
import { IPoint } from '../interfaces/points';

export const getPickupPoints = async () => {
  return axios.get<IPoint[]>('/api/shop/pickup_points');
};
export const getPickupCDEK = async (city = '') => {
  return axios.get<any[]>(`/api/shop/cdek/deliverypoints?city=${city}`);
};
export const getCDEKCities = async (name?: string) => {
  return axios.get<any[]>(`/api/shop/cdek/cities`, { params: { name } });
};
